import React, { StrictMode } from "react";
import { createRoot } from "react-dom/client";

// Import Bootstrap CSS and JS
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";

// Import your custom styles after Bootstrap
import "./styles.css";

import App from "./App";

const rootElement = document.getElementById("root");
if (!rootElement) {
  throw new Error(
    "Root element not found. Make sure index.html has a <div id='root'>.",
  );
}

const root = createRoot(rootElement);
root.render(
  <StrictMode>
    <App />
  </StrictMode>,
);
